// extracted by mini-css-extract-plugin
export var formContainer = "_ka-0";
export var message = "_ka-1";